import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import { Container, Card, CardBody, Form as BSForm } from "reactstrap";
import { Form } from "react-final-form";
import { Field } from "react-final-form-html5-validation";

import { getUpdatesList, addForceUpdate } from "../../requests/app";

import Button from "../../components/Form/Button";
import Input from "../../components/Form/Input";

const devices = {
  IOS: "iOS",
  ANDROID: "Android"
};
const types = {
  FORCE: "Force",
  OPTIONAL: "Optional"
};
class AppSettings extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      showForm: true
    };
  }
  componentDidMount() {
    if (!this.state.list) {
      getUpdatesList().then(response => {
        this.setState({ list: response.data });
      });
    }
  }
  addVersion = values => {
    const { index, ...rest } = values;
    return new Promise((resolve, reject) => {
      addForceUpdate({
        ...rest,
        features: values.features.join
          ? values.features
          : values.features.split(",")
      })
        .then(() => {
          this.setState({
            list: [
              ...this.state.list.slice(0, values.index),
              {
                ...rest,
                features: values.features.join
                  ? values.features
                  : values.features.split(",")
              },
              ...this.state.list.slice(values.index + 1)
            ],
            activeForm: null
          });
          return resolve(toast.success("با موفقیت ذخیره شد"));
        })
        .catch(reject);
    });
  };
  render() {
    return (
      <Container fluid>
        <div className="d-flex align-items-center mb-4">
          <h4>تنظیمات اپلیکیشن</h4>
        </div>
        {this.state.list && (
          <div>
            <h6>لیست نسخه‌ها</h6>
            {this.state.list.map((item, itemIndex) => (
              <Card className="mb-3 text-left" dir="ltr" key={item.id}>
                <CardBody>
                  {this.state.activeForm !== item.id &&
                    Object.keys(item).map((key, index) => (
                      <div
                        key={index}
                        onClick={e => this.setState({ activeForm: item.id })}
                      >
                        <strong>{key}:</strong>
                        {item[key]}
                      </div>
                    ))}
                  {this.state.activeForm === item.id && (
                    <Form
                      onSubmit={this.addVersion}
                      subscription={{
                        submitting: true,
                        pristine: true,
                        errors: true,
                        values: true
                      }}
                      initialValues={{ ...item, index: itemIndex }}
                      render={({
                        handleSubmit,
                        submitting,
                        pristine,
                        errors,
                        values
                      }) => (
                        <Card className="mb-3">
                          <CardBody>
                            <BSForm
                              id="channel-form"
                              onSubmit={handleSubmit}
                              className="text-left"
                              dir="ltr"
                            >
                              <Field type="hidden" name="index" id="index" />
                              <Field
                                name="userDevice"
                                id="userDevice"
                                type="select"
                                disabled
                                required
                                label="userDevice"
                                component={Input}
                                options={Object.keys(devices).map(key => (
                                  <option value={key} key={key}>
                                    {devices[key]}
                                  </option>
                                ))}
                              />
                              <Field
                                name="version"
                                id="version"
                                type="number"
                                required
                                label="version"
                                component={Input}
                              />
                              <Field
                                name="description"
                                id="description"
                                type="textarea"
                                required
                                label="description"
                                component={Input}
                              />
                              <Field
                                name="url"
                                id="url"
                                type="text"
                                label="url"
                                component={Input}
                              />
                              <Field
                                name="name"
                                id="name"
                                type="text"
                                required
                                label="name"
                                component={Input}
                              />
                              <Field
                                name="features"
                                id="features"
                                type="textarea"
                                required
                                label="features"
                                component={Input}
                              />
                              <Field
                                name="market"
                                id="market"
                                type="checkbox"
                                custom="switch"
                                label="market"
                                component={Input}
                              />
                              <Field
                                name="type"
                                id="type"
                                type="select"
                                required
                                label="type"
                                disabled
                                component={Input}
                                options={Object.keys(types).map(key => (
                                  <option value={key} key={key}>
                                    {types[key]}
                                  </option>
                                ))}
                              />
                              <div className="d-flex justify-content-end">
                                <Button
                                  type="button"
                                  outline
                                  className="mr-2"
                                  onClick={() =>
                                    this.setState({ activeForm: null })
                                  }
                                >
                                  Cancel
                                </Button>
                                <Button loading={submitting}>Submit</Button>
                              </div>
                            </BSForm>
                          </CardBody>
                        </Card>
                      )}
                    />
                  )}
                </CardBody>
              </Card>
            ))}
          </div>
        )}
      </Container>
    );
  }
}

export default connect(
  state => ({
    loading: state.app,
    appSetting: state.app
  }),
  dispatch => bindActionCreators({}, dispatch)
)(AppSettings);
